import { render, staticRenderFns } from "./mainevent.vue?vue&type=template&id=1fc0eeaa&scoped=true&"
import script from "./mainevent.vue?vue&type=script&lang=js&"
export * from "./mainevent.vue?vue&type=script&lang=js&"
import style0 from "./mainevent.vue?vue&type=style&index=0&id=1fc0eeaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0eeaa",
  null
  
)

export default component.exports